<template>
    <rkm-table
        :fields="fields"
        :items="data.form.cids"
        hide-filters
        hide-pagination
        tag="div"
    >
        <template v-slot:cell(info)="row">
            <rkm-icon
                :id="`pronto-atendimento-cid-info-${row.item.id}`"
                font-scale="1.5"
                icon="info-circle"
            />

            <rkm-popover
                :target="`pronto-atendimento-cid-info-${row.item.id}`"
                triggers="hover"
            >
                <div>{{ row.item.centroCusto.setor.nome }}</div>
                <div><rkm-icon icon="user" /> {{ row.item.lotacao.profissional.nome }} - {{ row.item.lotacao.ocupacao.nome }}</div>
                <div>Class. risco: {{ row.item.classificacaoRisco.nome }}</div>
                <div><rkm-icon :icon="['far', 'clock']" /> {{ row.item.dataHora }}</div>
            </rkm-popover>
        </template>
    </rkm-table>
</template>

<script>
export default {
    data: () => ({
        fields: [
            { key: 'info', label: '#', class: 'col-min text-center' },
            { key: 'cid.codigo', label: 'CID10' },
            { key: 'cid.nome', label: 'Descrição do CID10' },
        ],
    }),
    props: {
        data: { type: Object, required: true },
    },
}
</script>